namespace TabAurous.OMS {
    export interface RawMaterialMasterRow {
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        HSN?: string;
        TaxCode?: string;
        Pieces?: number;
        Weight?: number;
        PointerWeight?: number;
        Variance?: number;
        Rate?: number;
        SalesPrice?: number;
        CalcOnId?: number;
        CalcUnitId?: number;
        CostMethodId?: number;
        SettingId?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        IsCustomerItem?: boolean;
        Purity?: number;
        CreationDate?: string;
        CreationVoucherId?: number;
        HasBom?: boolean;
        IsDefaultSKU?: boolean;
        SKU?: string;
        ParentDesign?: string;
        IsNew?: boolean;
        IsFeatured?: boolean;
        IsConfigurable?: boolean;
        ForExchange?: boolean;
        ProductTypeName?: string;
        ProductTypeId?: number;
        ItemTypeId?: number;
        ItemType?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        Attribute?: string;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        MetalId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        PurchaseRate?: number;
        SalesRate?: number;
        CostId?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
    }

    export namespace RawMaterialMasterRow {
        export const idProperty = 'ProductId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'OMS.RawMaterialMaster';
        export const lookupKey = 'RawMaterial';

        export function getLookup(): Q.Lookup<RawMaterialMasterRow> {
            return Q.getLookup<RawMaterialMasterRow>('RawMaterial');
        }
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            AttributeId = "AttributeId",
            HSN = "HSN",
            TaxCode = "TaxCode",
            Pieces = "Pieces",
            Weight = "Weight",
            PointerWeight = "PointerWeight",
            Variance = "Variance",
            Rate = "Rate",
            SalesPrice = "SalesPrice",
            CalcOnId = "CalcOnId",
            CalcUnitId = "CalcUnitId",
            CostMethodId = "CostMethodId",
            SettingId = "SettingId",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            IsCustomerItem = "IsCustomerItem",
            Purity = "Purity",
            CreationDate = "CreationDate",
            CreationVoucherId = "CreationVoucherId",
            HasBom = "HasBom",
            IsDefaultSKU = "IsDefaultSKU",
            SKU = "SKU",
            ParentDesign = "ParentDesign",
            IsNew = "IsNew",
            IsFeatured = "IsFeatured",
            IsConfigurable = "IsConfigurable",
            ForExchange = "ForExchange",
            ProductTypeName = "ProductTypeName",
            ProductTypeId = "ProductTypeId",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            MetalId = "MetalId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            PurchaseRate = "PurchaseRate",
            SalesRate = "SalesRate",
            CostId = "CostId",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId"
        }
    }
}
